import { useTranslation } from "react-i18next";
import React, { memo } from 'react';
import { Breadcrumb, Dropdown, Tooltip } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import type { ItemType } from 'antd/es/menu/interface';
import './style.scss';

export interface BreadcrumbItem {
	id: number | string;
	name: string;
	isMine?: boolean | undefined
}

interface Props {
	basePath: string;
	items: BreadcrumbItem[];
	maxItems?: number;
	rootLabel?: React.ReactNode;
	onlyQuery?: boolean;
	preserveSearch?: boolean;
	rootPath?: string;
	queryBuilder?: (item: BreadcrumbItem) => Record<string, string>;
	onItemClick?: (item: any) => void;
}

const SmartBreadcrumb: React.FC<Props> = ({
	basePath,
	items = [],
	maxItems = 3,
	rootLabel = 'Kho học liệu',
	onlyQuery = false,
	preserveSearch = false,
	rootPath,
	queryBuilder,
	onItemClick
}) => {
const navigate = useNavigate();
	const location = useLocation();
	if (!items.length) return null;

	const goRoot = () => {
		navigate({ pathname: rootPath ?? location.pathname });
		if (onItemClick) {
			onItemClick({ id: 'root', name: String(rootLabel) });
		}
	};

	// const go = (item?: BreadcrumbItem | number | string, data?: any) => {
	// 	if (onItemClick) {
	// 		console.log('📍 Calling onItemClick with:', data);
	// 		onItemClick(data); // gọi đầu tiên
	// 	}
	// };



	const collapse = items.length > maxItems;
	const startIdx = collapse ? items.length - maxItems : 0;
	const visible = items.slice(startIdx);
	const hidden = collapse ? items.slice(0, startIdx) : [];

	const hiddenMenu: ItemType[] = hidden.map(i => ({
		key: i.id.toString(),
		label: <span onClick={() => onItemClick && onItemClick(i)}>{i.name}</span>,
	}));

	const renderItem = (i: BreadcrumbItem) => (
		<Breadcrumb.Item key={i.id}>
			<Tooltip title={i.name} placement="bottom">
				<a className="smart-breadcrumb__text" onClick={() => onItemClick && onItemClick(i)}>
					{i.name}
				</a>
			</Tooltip>
		</Breadcrumb.Item>
	);

	return (
		<Breadcrumb className="smart-breadcrumb">
			<Breadcrumb.Item>
				<Tooltip title={rootLabel}>
					<a onClick={() => goRoot()}>{rootLabel}</a>
				</Tooltip>
			</Breadcrumb.Item>

			{collapse && (
				<Breadcrumb.Item>
					<Dropdown menu={{ items: hiddenMenu }} trigger={['click']}>
						<a onClick={e => e.preventDefault()}>
							<EllipsisOutlined />
						</a>
					</Dropdown>
				</Breadcrumb.Item>
			)}

			{visible.map(renderItem)}
		</Breadcrumb>
	);
};

export default SmartBreadcrumb;
